<template>
  <x-button
    id="search-this-area"
    class="search-this-area__container"
    appearance-size="small"
    appearance-shape="pill"
    appearance-color="secondary-white"
    @click="handleClick"
  >
    <x-icon icon="magnifying-glass" color="black" />
    <x-body-text
      weight="medium"
      class="search-this-area"
      data-test="btn-search-this-area"
    >
      Search this Area
    </x-body-text>
  </x-button>
</template>

<script setup lang="ts">
import { useRoute, type RouteRecordNameGeneric } from 'vue-router'
import { routeNames } from '@/router/constants'
import fishRoutes from '@/fish/router/constants'

import pubsub from '@/lib/pubsub'

import { setShowSearchArea, searchIsActive } from '@/services/search-service'
import marketingEventService from '@/services/marketing-event-service'
import { camera } from '@/services/map-service'

import xButton from '@/components/shared/x-button/index.vue'
import xIcon from '@/components/shared/x-icon/index.vue'
import xBodyText from '@/components/shared/x-body-text/index.vue'

const route = useRoute()

/**
 * Route names that represent "Discover UI" views where Search This Area is used
 */
const discoverRoutes: RouteRecordNameGeneric[] = [
  fishRoutes.WATERBODIES,
  fishRoutes.FISH_MAP,
  routeNames.FISH_ZERO_QUERY_SEARCH,
  routeNames.FISH_QUICK_SEARCH,
]

const handleClick = () => {
  sendMarketingEvent()
  setShowSearchArea(false)
  if (discoverRoutes.includes(route.name) && !searchIsActive()) {
    pubsub.publish('discover-search-this-area')
  } else if (searchIsActive()) {
    pubsub.publish('search-this-area')
  }
}

const sendMarketingEvent = () => {
  let origin = null
  if (searchIsActive()) {
    origin = 'search'
  } else if (route.name === fishRoutes.FISH_MAP) {
    origin = 'map'
  } else if (discoverRoutes.includes(route.name)) {
    origin = 'discover card'
  }
  marketingEventService.publish('search_this_area_clicked', {
    zoom_level: camera()?.location?.height.toFixed(1) ?? null,
    origin,
  })
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_shadow.scss';
@use '@/styles/system/_breakpoints.scss';
@use '@/styles/_layer-map.scss';

.search-this-area {
  padding-left: 12px;

  &__container {
    position: absolute;
    left: 0;
    right: 0;
    margin-inline: auto;
    width: fit-content;
    top: 80px;
    z-index: layer-map.$z-index-level-card;
    box-shadow: shadow.$Low;

    &:hover {
      cursor: pointer;
    }

    @include breakpoints.mobile {
      bottom: 30px;
      top: unset;
    }

    .with-banner & {
      top: calc(80px + var(--map-banner-height));
    }
  }
}
</style>
